import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter, Link } from "react-router-dom"
//import axios from 'axios'
//import { connectNode } from '../../utils/global.js'
import AuthService from '../../services/auth/auth.service.js'
import WarningIcon from '@material-ui/icons/Warning'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { FaRegUserCircle } from 'react-icons/fa'
import { TextField, InputAdornment, IconButton } from "@material-ui/core"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
//import { loadAuthUser } from '../../actions/auth'
import { loadLocationWithMessage } from '../../actions/location'

class Login extends Component {
  constructor() {
      super();
      this.state = {
        username: '',
        password: '',
        loading: false,
        showPassword: false,
        message: ''
      }
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.setState({
        [event.target.name]: event.target.value
    })
  }

  handleNext = () => {
    console.log('clicked')
console.log(this.props.history)
console.log(this.props.location)
const path = '/forgot_password'
  this.props.onLoadLocation(path)
  this.props.history.push(path)
  }

  handleClickShowPassword = () => {
    this.setState({
        showPassword: !this.state.showPassword
    })
    //setValues({ ...values, showPassword: !values.showPassword });
  };

  handleMouseDownPassword = (e) => {
    e.preventDefault();
  };

  handleSubmit(event) {
      event.preventDefault()
      AuthService.login(this.state.username, this.state.password)
      .then((response) => {
        //console.log(response.message)
        //if(response !== -1 && response !== -2 && response !== -3 && response !== -4) {
        if (response && response.loggedIn === true) {
          var path_location = window.location.pathname
          this.props.onLoadPages(response)
          if(path_location === '/login' || path_location === '/') { // '/' for haven't no Home page
            // check registration_step //
            path_location = '/dashboard'
            if(response.role < 5 || response.role == 6) {
              path_location = '/admin/patient_search' //patient_list
            }

            if(response.role == 5) {
              if((response.p_st == 1 || response.p_st == 2 || response.p_st == null)
              && response.a_status == null) {
                path_location = '/member/overview_registration'
              }
              if(response.p_st == 2 && response.a_status != null) { // active baseline //
                path_location = '/member/assessment/overview/m/-1'
              }
              if(response.p_st == 6) { // active baseline //
                path_location = '/dashboard'
              }
            }
          }
          this.props.onLoadLocation(path_location)
          this.props.history.push(path_location)
        } else {
          var txt_err = ''
          if(response == -2) {
            txt_err = 'You have not changed your password more than 180 days. Please click Forgot Password to reset it.'
          } else if(response == -3) {
            txt_err = 'Too many failed attempts. We sent a link to reset your password to your email. If you don\'t receive the email, please click Forgot Password.'
          } else if(response == -4) {
            txt_err = 'Sorry, you don\'t have permission to access the FITT-BD'
          } else {
            txt_err = 'Password mismatch. Please try again. '
          }
          this.setState({
              username: '',
              password: '',
              message: txt_err,
          })
        }
      }).catch( error => {
        console.log(error)
      })
  }

  render() {
    return (
      <div className="row" id="wrapper-login">
        <div className="small-12 columns welcome_txt">
          Welcome to the FITT-BD portal!
        </div>
        <div className="small-12 columns">
          <div className="logo"><FaRegUserCircle /></div>
        </div>
        <div className="small-12 columns">
          { this.state.message !== '' &&
            <div className="warning_msg9">
              <div className="float_left1"><WarningIcon /></div>
              <div className="txt_warning_msg1">{ this.state.message }</div>
            </div>
          }
          { (this.props.txt_message !== '' && this.props.txt_message !== undefined && this.state.message === '') &&
            <div className="warning_msg8">
              <div className="float_left1"><CheckCircleOutlineIcon /></div>
              <div className="txt_warning_msg1">{ this.props.txt_message }</div>
            </div>
          }
          <form id="login" onSubmit={this.handleSubmit}>
            <div>
              <input className="form-input"
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Username"
                  value={this.state.username}
                  onChange={this.handleChange} />
            </div>
            <div className="form-group">
              <TextField className="form-input frm_password"
                  placeholder="Password"
                  type={this.state.showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  variant="outlined"
                  value={this.state.password}
                  onChange={this.handleChange}
                  InputProps={{
                   endAdornment: (
                     <InputAdornment position="right">
                       <IconButton disableRipple={true} size="small"
                         aria-label="toggle password visibility"
                         onClick={this.handleClickShowPassword}
                         onMouseDown={this.handleMouseDownPassword}
                       >
                         {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                       </IconButton>
                     </InputAdornment>
                   )
                 }}
              />
            </div>
            <div className="form-group ">
              <button type="submit">Login</button>
            </div>
            <div className="form-group top_space1">
            <button
  type="button"
  onClick={() => window.location.assign('/forgot_password')}
>
  Forgot Password
</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    txt_message: state.locationReducer.txt_message,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route) {
    dispatch(loadLocationWithMessage(route, ''))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Login)
//export default Login
